import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=340511bc&scoped=true"
import script from "./CreateProfile.vue?vue&type=script&lang=ts"
export * from "./CreateProfile.vue?vue&type=script&lang=ts"
import style0 from "./CreateProfile.vue?vue&type=style&index=0&id=340511bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340511bc",
  null
  
)

export default component.exports